import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { useCallback, useState } from "react";
import './changePasswordModal.css';
import { showPromiseNotification } from "../../common/notification";
import { useDispatch } from "react-redux";
import { updatePassword } from "../../slices/authSlice";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import '../../i18'; 

function ChangePasswordModal({ isOpen, onClose }) {
    const { t } = useTranslation();
    const [showCurrentPassword, setShowCurrentPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const changePasswordSchema = Yup.object().shape({
        current_password: Yup.string()
            .trim()
            .required(t('required',{field : t("password")}))
            .matches(
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                t('passwordValidation')
            ),
        new_password: Yup.string()
            .trim()
            .required(t('required',{field : t("new_password")}))
            .matches(
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                t('passwordValidation')
            ),
        confirm_password: Yup.string()
            .trim()
            .required(t('required',{field : t("confirm_password")}))
            .oneOf([Yup.ref('new_password'), null], t('matchPassword'))
    });

    const formOptions = { resolver: yupResolver(changePasswordSchema) };
    const { register, handleSubmit, formState, reset } = useForm(formOptions);
    const { errors } = formState;

    const handleFormSubmit = useCallback(
        async (data) => {
            const myPromise = new Promise((resolve, reject) => {
                dispatch(
                    updatePassword({
                        payload: {
                            ...data,
                        },
                    })
                )
                    .then((response) => {
                        if (response.payload.code == 200) {
                            onClose();
                            resolve(response.payload)
                            navigate("/home")
                        }
                        else {
                            reject(response.payload)
                        }
                    });
            });
            showPromiseNotification(myPromise);
            reset();
        }
    )

    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-container">
                <form onSubmit={handleSubmit(handleFormSubmit)}>
                    <div>
                        <div className="modal-header-change">
                            <h6 className="ChangePassHeading text-center">{t('changePasswordModalHeading')}</h6>
                            <button
                                type="button"
                                className="btn-close"
                                aria-label="Close"
                                onClick={onClose}
                            />
                        </div>
                        <div className="modal-body">
                            <div className="changeInput-main">
                                {/* Current Password Input */}
                                <div className="changeInput-box">
                                    <div className="loginPasswordInputBox single-input-inner m-0 input-group">
                                        <input
                                            type={showCurrentPassword ? "text" : "password"}
                                            className="form-control"
                                            placeholder={t("enterFieldName",{field: t("Current_Password")})}
                                            autoComplete="off"
                                            {...register('current_password')}
                                        />
                                        <a
                                            href="#"
                                            className="input-group-text"
                                            onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                                        >
                                            <img
                                                src={showCurrentPassword ? process.env.PUBLIC_URL + "/assets/img/icon/open-eye.svg" : process.env.PUBLIC_URL + "/assets/img/icon/close-eye.svg"}
                                                alt="Toggle password visibility"
                                                className="CloseEye"
                                            />
                                        </a>
                                    </div>
                                    <p className="text-danger">{errors.current_password?.message}</p>
                                </div>
                                {/* New Password Input */}
                                <div className="changeInput-box">
                                    <div className="loginPasswordInputBox single-input-inner m-0 input-group">
                                        <input
                                            type={showNewPassword ? "text" : "password"}
                                            className="form-control"
                                            placeholder={t("enterFieldName",{field: t("New_Password")})}
                                            autoComplete="off"
                                            {...register('new_password')}
                                        />
                                        <a
                                            href="#"
                                            className="input-group-text"
                                            onClick={() => setShowNewPassword(!showNewPassword)}
                                        >
                                            <img
                                                src={showNewPassword ? process.env.PUBLIC_URL + "/assets/img/icon/open-eye.svg" : process.env.PUBLIC_URL + "/assets/img/icon/close-eye.svg"}
                                                alt="Toggle password visibility"
                                                className="CloseEye"
                                            />
                                        </a>
                                    </div>
                                    <p className="text-danger">{errors.new_password?.message}</p>
                                </div>
                                {/* Confirm Password Input */}
                                <div className="changeInput-box">
                                    <div className="loginPasswordInputBox single-input-inner m-0 input-group">
                                        <input
                                            type={showConfirmPassword ? "text" : "password"}
                                            className="form-control"
                                            placeholder={t("enterFieldName",{field: t("Confirm_Password")})}
                                            autoComplete="off"
                                            {...register('confirm_password')}
                                        />
                                        <a
                                            href="#"
                                            className="input-group-text"
                                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                        >
                                            <img
                                                src={showConfirmPassword ? process.env.PUBLIC_URL + "/assets/img/icon/open-eye.svg" : process.env.PUBLIC_URL + "/assets/img/icon/close-eye.svg"}
                                                alt="Toggle password visibility"
                                                className="CloseEye"
                                            />
                                        </a>
                                    </div>
                                    <p className="text-danger">{errors.confirm_password?.message}</p>
                                </div>
                                {/* Submit Button */}
                                <div className="changeInput-box">
                                    <button className="btn btn-base w-100" type="submit">
                                        {t('submit')}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default ChangePasswordModal;
